export default __webpack_public_path__ + "static/luke-barton-0610249a76fe4e64e01d31829187b49c.png";